import { ReactNode } from 'react';
import { mrrTheme } from './theme';
import { GetBrandTheme } from '@leadflow/shared/theme/GetBrandTheme';

const ThemeProviderWrapper = ({ children }: { children: ReactNode }) => {
  return <GetBrandTheme brandTheme={mrrTheme}>{children}</GetBrandTheme>;
};

export default ThemeProviderWrapper;
